import { createSelector } from '@reduxjs/toolkit';
import type { SpatialLayer } from '../../GlobalMapSearch.types';

/** Layer key for Axon police tracking — handled by its own search pipeline. */
const AXON_KEY = 'axon_police_tracking';

const EMPTY: SpatialLayer[] = [];

const selectDynamicLayers = (state: unknown): SpatialLayer[] => {
  const slice = (
    state as { spatialLayers?: { dynamicLayers?: SpatialLayer[] } }
  ).spatialLayers?.dynamicLayers;
  return slice ?? EMPTY;
};

/**
 * Active (user-toggled-on) dynamic spatial layers, excluding Axon. Axon has
 * its own pre-formatted dataset (`selectAxon`) and is searched via
 * `axonSearch`; everything else here goes through the generic
 * `spatialAttributeSearch` path.
 */
export const selectActiveDynamicLayers = createSelector(
  [selectDynamicLayers],
  layers => layers.filter(l => l.isChecked && l.key !== AXON_KEY),
);
